import { FaMapMarkedAlt } from "react-icons/fa";
import { FaBus, FaImages, FaUsers } from "react-icons/fa6";

import { MenuSectionData } from "@/lib/types/nav";

export const menuSections: MenuSectionData[] = [
  {
    key: "tours",
    label: "Tours",
    icon: FaBus,
    iconSize: 25,
    items: [
      {
        href: "/new-orleans-tours/french-quarter-walking-tour",
        label: "French Quarter Tour",
      },
      {
        href: "/new-orleans-tours/garden-district-walking-tour",
        label: "Garden District Tour",
      },
      {
        href: "/new-orleans-tours/new-orleans-ghost-tour",
        label: "New Orleans Ghost Tour",
      },
      {
        href: "/new-orleans-tours/new-orleans-ghost-bus-tour",
        label: "New Orleans Ghost Bus Tour",
      },
    ],
  },
  {
    key: "groups",
    label: "Groups",
    icon: FaUsers,
    iconSize: 25,
    items: [
      { href: "/groups/group-tours", label: "Group Tours" },
      { href: "/groups/custom-tours", label: "Custom Tours" },
    ],
  },
  {
    key: "locations",
    label: "Locations",
    icon: FaMapMarkedAlt,
    iconSize: 25,
    items: [{ href: "/locations/941-decatur", label: "941 Decatur" }],
  },
  {
    key: "blog",
    label: "Blog",
    icon: FaImages,
    iconSize: 24,
    items: [
      { href: "/category/blog", label: "NOLWT Blog" },
      { href: "/category/haunted-places", label: "Haunted Places" },
    ],
  },
];

export const linkMatchingMap: Record<string, string[]> = {
  tours: [
    "/new-orleans-tours/french-quarter-walking-tour",
    "/new-orleans-tours/garden-district-walking-tour",
    "/new-orleans-tours/new-orleans-ghost-tour",
    "/new-orleans-tours/new-orleans-ghost-bus-tour",
  ],
  groups: ["/groups/group-tours", "/groups/custom-tours"],
  blog: ["/category/blog", "/category/haunted-places"],
  locations: ["/locations/941-decatur"],
};
